import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_NON_NATIONAL_EXAM_CREATE_CANDIDATE } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PostNonNationalExamCreateCandidateResponse {}

export interface PostNonNationalExamCreateCandidateRequest {
  declaringPerson: {
    name: string;
    uinFinPassport: string;
  };
  singaporeBirthCertNo: string;
  motherTongueLanguageToBeTaken: string;
  dateOfAttainedSPRStatus: string; // '2022-05-05';
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: PostNonNationalExamCreateCandidateResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostNonNationalExamCreateCandidate = ({ uuid, onSuccess, onError }: Input) => {
  const postNonNationalExamRegistrationPayment = async (
    payload: PostNonNationalExamCreateCandidateRequest
  ) => {
    const res = await axiosClient.post<PostNonNationalExamCreateCandidateResponse>(
      POST_NON_NATIONAL_EXAM_CREATE_CANDIDATE(uuid),
      payload
    );
    return res.data;
  };

  return useCustomMutation(postNonNationalExamRegistrationPayment, {
    onSuccess,
    onError,
  });
};
